import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=d300975a&scoped=true&"
import script from "./MemberCard.vue?vue&type=script&lang=js&"
export * from "./MemberCard.vue?vue&type=script&lang=js&"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=d300975a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d300975a",
  null
  
)

export default component.exports